// extracted by mini-css-extract-plugin
export default {"bundleContainer":"MixAndMatchBundle-bundleContainer-PRN","productsContainer":"MixAndMatchBundle-productsContainer-El1"};